import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const withoutLegacyAuthority = (values = {}) => {
  const body = { ...values || {} };
  delete body["auth_key"];
  delete body["action"];
  return body;
};

const requestHeaders = (extra = {}) => ({
  headers: { ...authHeader(), ...extra },
});

const create = (values) => {
  const action = "afterlogin/smsuses/store";
  const body = withoutLegacyAuthority(values);
  const key = body.idempotency_key;
  const extra = key ? { "Idempotency-Key": key } : {};
  return axios.post(API_URL + action, body, requestHeaders(extra));
};

const options = (values) => {
  const action = "afterlogin/smsuses/options";
  return axios.post(API_URL + action, withoutLegacyAuthority(values), requestHeaders());
};
const smspayment = (values) => {
  const action = `afterlogin/smsuses/smspayment`;
  return axios.post(API_URL + action, withoutLegacyAuthority(values), requestHeaders());
};

const smspaymentfailed = (values) => {
  const action = `afterlogin/smsuses/smspaymentfailed`;
  return axios.post(API_URL + action, withoutLegacyAuthority(values), requestHeaders());
};

const smsDefaultList = (values) => {
  const action = `afterlogin/creditcard/listPaymentMethod`;
  const data = {};
  if (values && values.client_id !== undefined && values.client_id !== null && values.client_id !== "") {
    data.client_id = values.client_id;
  }
  return axios.post(API_URL + action, data, requestHeaders());
};

const smsusesApiController = {
  create,
  options,
  smspayment,
  smspaymentfailed,
  smsDefaultList,
};
export default smsusesApiController;
